export default "__VITE_ASSET__C0KJM$mn__"